module.exports = __webpack_public_path__ + "roboto-bolditalic-webfont.7e7700dbf7b0b36bd3b9.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-bolditalic-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto-bolditalic-webfont.ttf
// module chunks = styles